import axios, { AxiosError } from "axios";
import { IResponse } from "./interactionApi";

export function handleError(error: unknown, mess: string): any {
  console.log(mess, error);
  if (axios.isAxiosError(error)) {
    const serverError = error as AxiosError<unknown>;
    if (serverError && serverError.response) {
      return serverError.response.data;
    }
  }
  return { message: `Error: ${mess}` };
}

export function handleResponse<T>(data: IResponse<T>): T {
  if (data.success) return data as unknown as T;
  return { errorMsg: data.message } as unknown as T;
}

export function handleCountdownText(message: string) {
  if (!message) return { text: "", time: "" };
  const match = message.match(/(.*?)(\d{1,2}):(\d{2})/);

  const prefix = match?.[1]; // "Chúng tôi có thể gửi mã mới sau "
  const minutes = parseInt(match?.[2] || "0", 10); // 3
  const seconds = parseInt(match?.[3] || "0", 10); // 00

  const totalSeconds: number = minutes * 60 + seconds; // => 180

  return { text: prefix, time: totalSeconds };
}

export function formatRouteName(route: string) {
  return route.replace(/-/g, " ");
}

export function revertRouteName(formatted: string) {
  return formatted.replace(/ /g, "-");
}

export function formatRouteNameWithPageId(route: string) {
  const parts = route.split("-");
  const pageId = parts.pop(); // lấy phần cuối là pageId
  const name = parts.join(" "); // nối lại phần còn lại làm tên

  return {
    name,
    pageId: pageId || ""
  };
}

export const randomString = (length: number): string => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};
export const randomNumber = (length: number): string => {
  let result = "";
  const characters = "0123456789";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};
